import { render, staticRenderFns } from "./FleetOverview.vue?vue&type=template&id=de061bfa&scoped=true&"
import script from "./FleetOverview.vue?vue&type=script&lang=ts&"
export * from "./FleetOverview.vue?vue&type=script&lang=ts&"
import style0 from "./FleetOverview.vue?vue&type=style&index=0&id=de061bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de061bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
